import { Component, OnInit } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';

import { i18nPipe } from "../../helper/i18n.pipes";
import { DefaultLayoutComponent } from '../../component/common/default-layout/default-layout.component';

import { IFCAppServices } from "../../services/ifcapp.service";
import { BaseService } from '../../services/base.service';
import { BaseResponse, ICRewardsList } from '../../model/ifcapp.models';

import * as moment from 'moment';
import { StateService } from '../../services/state.service';

@Component({
  selector: 'app-rewards-list',
  templateUrl: './rewards-list.component.html',
  styleUrls: ['./rewards-list.component.scss']
})
export class RewardsListComponent implements OnInit {

  isLoading = false;
  requestData;
  hash;
  debug = "Y";
  availablePoints:number = 0;
  language = 'en';
  rewardList;
  memberid:string = '1';
  // rewardId:string = '0';
  memberPoints:number = 0;
  testing = false;
  decryptData = {};
  affiliated_card_id:string = "0";
  campaign_id:number = 0;
  appToken:string = "";
  platform:string = "IOS";
  deviceid:string = "";
  version:string = "";
  sessionkey:string = "";
  campaignId:string = "";
  screenSize = { height: 0, width:0 };
  fromWechat:boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute, 
    public state: StateService,
    private ifcAppServices: IFCAppServices, 
    private i18nPipe: i18nPipe, 
    private router: Router, 
    private layout: DefaultLayoutComponent,
    public _location: Location,

  ) {
    this.isLoading = true;
    this.screenSize.height = document.documentElement.clientHeight;
    this.screenSize.width = document.documentElement.clientWidth;
    this.activatedRoute.queryParams.subscribe((params) => {

      if (params['lang'] !== null && params['lang'] !== undefined ) {
        this.language = params['lang'];
        //lang (“zh_Hant” / “zh_Hans” / “en_US” , default en_US)
      }
      if (params['requestData'] !== null && params['requestData'] !== undefined ) {
        this.requestData = decodeURI(params['requestData']);
      }
      if (params['hash'] !== null && params['hash'] !== undefined ) {
        this.hash = params['hash'];
      }
      if (params['testing'] !== null && params['testing'] !== undefined) {
        this.testing = params['testing'];
      }
      if (params['fromWechat'] !== null && params['fromWechat'] !== undefined) {
        this.fromWechat = JSON.parse(params['fromWechat']);
        console.log('reward-list-fromWechat', this.fromWechat)
      }
      
    });
  }

  async ngOnInit() {
    if (this.testing) {
      this.requestData = 'agVcMmMZcR8nJLYy5nbBq9ASfukBMVzFZ5aOiDyVsHQfLFdT8Ni5XvzfRFcszlcg5YXB6HdZV2gCTOwM9iQr67N+uhquQxPaXdo2FgbTYtmdfiFXgoUejgKQivnIngIcrUyG/DEQdfc7KksrwSbBfG7glf2ZLGsPqC7C0L+N4Ymn+jEl2xkZ8vmHG8eecEDWOPfNrgCqGcFxaqlyg/w8xzsQ8+Ffp3BykUzpmmk0UHJH5qlp/YKkX0Bp9XI5uefQA9pcXgQYz4AU0q6wQkOSIODm2zEc6m32rJQ+MoRrzwna/MloS+9phbqTVOa44EIEIrf3X9crXdXS68kPt8xqIAf/Uk4l3ZY+isJ7pbUMd9wIlJumDb4CbBSEud4UClFU1grBzANzS6pYCpUQOI+5sA==';
      this.hash = "803762618c55d4a21b4d954f2b5fc8bd8a40d541";
    }

    console.log(this.requestData.replace(/\r?\n|\r/g,""))
    //{"current_time":"2021-08-02 12:33:02","lang":"en_US","member_id":100394,"affiliated_card_id":0,"app_token":"ks6Imnrexz3d6cLuOvrW9oh8HU1MD0LVKfXvc247","platform":"IOS","deviceid":"20F6A17C-A21E-4753-9D67-B127089B57B2","version":"4.3","sessionkey":"9ad575055bf74747b5e8f317acace35d","campaign_id":15}

    this.decryptData = JSON.parse(this.ifcAppServices.getICRewardDecryptData(this.requestData.replace(/\r?\n|\r/g,"")));
    console.log(this.decryptData);
    console.log(this.decryptData["member_id"]);
    this.memberid = this.decryptData["member_id"] ? this.decryptData["member_id"].toString() : this.memberid;
    this.appToken = this.decryptData["app_token"] ? this.decryptData["app_token"] : this.appToken;
    this.platform = this.decryptData["platform"] ? this.decryptData["platform"] : this.platform;
    this.sessionkey = this.decryptData["sessionkey"] ? this.decryptData["sessionkey"] : this.sessionkey;
    this.deviceid = this.decryptData["deviceid"] ? this.decryptData["deviceid"] : this.deviceid;
    this.affiliated_card_id = this.decryptData["affiliated_card_id"] ? this.decryptData["affiliated_card_id"].toString(): this.affiliated_card_id;

    let encryptedRequestObject = this.ifcAppServices.encryptICRewardData(JSON.stringify(this.decryptData));
    console.log(encryptedRequestObject);
    this.requestData = encryptedRequestObject;
    this.hash = this.ifcAppServices.hashICRewardData(JSON.stringify(this.decryptData));
    console.log(this.hash)
    console.log(this.memberid)
    // this.ifcAppServices.setIFCApiHeader(this.memberid);
    this.ifcAppServices.setIFCApiHeader(this.language, this.platform, this.memberid, this.affiliated_card_id, this.sessionkey, this.deviceid)


    let body = new FormData();
    body.append('request_data', this.requestData);
    body.append('hash', this.hash);
    body.append('debug', this.debug);
    // let request = {
    //   request_data: this.requestData,
    //   hash: this.hash,
    //   debug: this.debug,
    // };

    
    let rewardListResponse = await this.ifcAppServices.getRewardList(body);
    this.memberPoints = this.ifcAppServices.numberWithCommas(rewardListResponse.available_points);
    this.rewardList = rewardListResponse.data;
    // console.log(this.rewardList.points)
    for (let i = 0; i < this.rewardList.length; i++) {
      if (this.language == 'zh_Hant') {
        this.rewardList[i]['reward_name'] = this.rewardList[i]['reward_name_tc'];
      } else if (this.language == 'zh_Hans') {
        this.rewardList[i]['reward_name'] = this.rewardList[i]['reward_name_sc'];
      } else {
        this.rewardList[i]['reward_name'] = this.rewardList[i]['reward_name_en'];
      }
      this.rewardList[i].points = this.ifcAppServices.numberWithCommas(this.rewardList[i].points);
      
    }
    console.log(this.rewardList);
    console.log(this.rewardList[0]);

    this.isLoading = false;
    // 2  - Network error

  }

}
